// extracted by mini-css-extract-plugin
export default {"Input":"index_Input_Zo9CC","error":"index_error_CId95"};